<template>
    <!-- 总平台管理－新增优惠券-->
    <content-view>
        <div class="newAddcoupons">
            <a-form :form="form">
                <a-form-item v-bind="formItemLayout" label="优惠券名称">
                    <a-input
                        placeholder="请输入"
                        :disabled="isDisable"
                        v-decorator="[
                            'name',
                            {rules: [{ required: true, message: '优惠券名称!', whitespace: true }]}
                        ]"
                    />
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="优惠券类型">
                    <a-radio-group v-decorator="['type',{initialValue: 1}]" @change="onChangeType" :disabled="isDisable">
                        <a-radio :value="1">满减券</a-radio>
                        <a-radio :value="2">折扣券</a-radio>
                        <a-radio :value="3">分享券</a-radio>
                    </a-radio-group>
                </a-form-item>

                <!-- 分享券 -->
                <div v-if="isShareCoupons">
                    <a-form-item v-bind="formItemLayout" label="分享券关联优惠券">
                        <a-select
                        placeholder="请选择"
                        :disabled="isDisable"
                        v-decorator="['couponId']"
                        >
                            <a-select-option :value="item.id" v-for="item in ticketList" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="奖励券类型">
                        <a-radio-group v-decorator="['rewardType',{initialValue: 1}]" @change="onChangeRewardType" :disabled="isDisable">
                            <a-radio :value="1">优惠券</a-radio>
                            <a-radio :value="2">票券</a-radio>
                            <a-radio :value="0">无</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="showReward" v-bind="formItemLayout" label="关联奖励券">
                        <a-select
                        placeholder="请选择"
                        :disabled="isDisable"
                        v-decorator="['rewardId', {rules: [{required: showReward, message: '请选择关联奖励券' }]}]"
                        >
                            <a-select-option :value="item.id" v-for="item in ticketRewardList" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </div>

                <!-- 满减券、折扣券 -->
                <div v-else>
                    <a-form-item v-bind="formItemLayout" :required="true" label="使用门槛">
                        <a-radio-group v-model="required" :disabled="isDisable" @change="onChangeRequired">
                            <a-radio :value="1">有门槛</a-radio>
                            <a-radio :value="0">无门槛</a-radio>
                            <span v-if="required==1&&type==1">满
                                <a-input-number style="width:80px" :min="0" v-model="reachAmount" placeholder :disabled="isDisable"/>减
                                <a-input-number style="width:100px" :min="0" v-model="reduceAmount" placeholder :disabled="isDisable"/>(元)
                            </span>
                            <span v-if="required==1&&type==2">满
                                <a-input-number style="width:80px" :min="0" v-model="reachAmount" placeholder :disabled="isDisable"/>打
                                <a-input-number style="width:80px" :min="0.1" :max="9.9" :precision="1" v-model="discountRate" placeholder :disabled="isDisable"/>折 ({{discountRate ? discountRate*10 : 0}}%)
                            </span>
                            <span v-if="required==0&&type==1">减
                                <a-input-number style="width:80px" :min="0" v-model="reduceAmount" placeholder :disabled="isDisable"/>(元)
                            </span>
                            <span v-if="required==0&&type==2">打
                                <a-input-number style="width:80px" :min="0" v-model="discountRate" placeholder :disabled="isDisable"/>折 ({{discountRate ? discountRate*10 : 0}}%)
                            </span>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" :required="true" label="适用类型">
                        <a-radio-group v-decorator="['suitType',{initialValue: 1}]" @change="onChangeTicketType" :disabled="isDisable">
                            <a-radio :value="1">门票</a-radio>
                            <a-radio :value="2">餐饮</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="isShowTicket" v-bind="formItemLayout" :required="true" label="适用票券" >
                        <a-radio-group v-decorator="['suitTicketOption',{initialValue: 0}]" @change="onChangeSuitTicket" :disabled="isDisable">
                            <a-radio :value="0">全部票券通用</a-radio>
                            <a-radio :value="1">部分票券适用</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="isShowTicket && isShowTicketList" v-bind="formItemLayout" label="适用票券">
                        <a-select
                        placeholder="请选择"
                        mode="multiple"
                        :disabled="isDisable"
                        v-decorator="['ticketIdList',{rules: [{required: isShowTicket && isShowTicketList, message: '请选择适用票券',}]}]"
                        >
                            <a-select-option :value="item.id" v-for="item in ticketIdList" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </div>

                <a-form-item label="分享语" v-bind="formItemLayout">
                    <a-input
                    placeholder="请输入分享语(20字符以内)"
                    :disabled="isDisable"
                    v-decorator="['shareRemark']"
                    ></a-input>
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="生效时间" required>
                    <a-radio-group @change="onChangeTime" v-decorator="['dateType',{initialValue: 0}]" :disabled="isDisable">
                        <div class="mb16">
                            <a-radio :value="0">
                                指定有效天数
                                <span>
                                    自获得日期起，有效期 
                                    <a-input-number :disabled="isShowValidDates || isDisable" v-decorator="['validDates']" :min="1" :step="1" /> 天
                                </span>
                            </a-radio>
                        </div>
                        <div>
                            <a-radio :value="1">
                                指定有效日期
                                <span>
                                    <a-range-picker
                                        style="width: 360px"
                                        :disabled="!isShowValidDates || isDisable"
                                        showTime
                                        @change="onChangePicker"
                                        format="YYYY-MM-DD HH:mm:ss"
                                        v-decorator="['rangePicker']"
                                    />
                                </span>
                            </a-radio>
                        </div>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="发送至">
                    <a-radio-group v-decorator="['sendType',{initialValue: 1}]" :disabled="isDisable">
                        <a-radio :value="1">全部</a-radio>
                        <a-radio :value="2">APP</a-radio>
                        <a-radio :value="3">小程序</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="发送时间">
                    <a-radio-group v-decorator="['sendTimeOption',{initialValue: 1}]" :disabled="isDisable" @change="onChangeSendTime">
                        <a-radio :value="1">立即发送</a-radio>
                        <a-radio :value="0">设置发送时间</a-radio>
                        <a-radio :value="2">暂不发送</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-show="isShowSendTime" v-bind="formItemLayout" label="设置发送时间">
                    <a-date-picker
                        style="width: 100%"
                        showTime
                        format="YYYY-MM-DD HH:mm:ss"
                        :disabled="isDisable"
                        v-decorator="['sendTime', {rules: [{required: isShowSendTime, message: '请选择发送时间' }]}]"
                    />
                </a-form-item>
                <a-form-item v-bind="formItemLayout" label="数量限制">
                    <a-input
                    placeholder="请输入"
                    :disabled="isDisable"
                    v-decorator="[
                        'limitNum',
                        {rules: [{ required: true, message: '数量限制!', whitespace: true }]}
                    ]"
                    />
                    <div class="text-disabled">'-1'表示不限量</div>
                </a-form-item>

                <!-- 优惠券领取条件设置 -->
                <a-card title="优惠券领取条件设置" :bordered="false" v-show="isShowGetCondition">
                    <a-form-item v-bind="formItemLayout" label="用户" :required="true">
                        <a-radio-group v-decorator="['userLimit',{initialValue: 0}]" :disabled="isDisable">
                            <a-radio :value="0">全部</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="领取条件" :required="true">
                        <a-radio-group v-decorator="['takeCondition',{initialValue: 1}]" :disabled="isDisable || isDisabledForSendTime" @change="onChangeShowGet">
                            <a-radio :value="1">满足以下行为领取</a-radio>
                            <a-radio :value="0">无条件领取</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <div class="ml80" v-show="isShowGet">
                        <a-form-item v-bind="formItemLayout" label="行为设置">
                            1、在时间：
                            <a-radio defaultChecked :disabled="isDisable">限定时间</a-radio>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label=" " :colon="false">
                            <a-range-picker
                                style="width: 100%"
                                :disabled="isDisable"
                                showTime
                                format="YYYY-MM-DD HH:mm:ss"
                                v-decorator="['setTime', {rules: [{ type: 'array', required: isShowGet, message: '生效时间' }]}]"
                            />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label=" " :colon="false">
                            2、在用户：
                            <a-radio-group v-decorator="['useType',{initialValue: 1}]" :disabled="isDisable" @change="onChangeUseType">
                                <a-radio :value="1">优惠券</a-radio>
                                <a-radio :value="2">票券</a-radio>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label=" " :colon="false">
                            <a-select
                            placeholder="请选择"
                            :disabled="isDisable"
                            v-decorator="['behaviorType',{rules: [{required: isShowGet, message: '请选择',}]}]"
                            >
                                <a-select-option v-if="!isShowCoupons" :value="1">购买票券</a-select-option>
                                <a-select-option v-if="!isShowCoupons" :value="2">核销票券</a-select-option>
                                <a-select-option v-if="!isShowCoupons" :value="3">首次核销票券</a-select-option>
                                <a-select-option v-if="isShowCoupons" :value="4">使用优惠券</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label=" " :colon="false">
                            <a-select
                            placeholder="请选择"
                            :disabled="isDisable"
                            v-decorator="['ticketId',{rules: [{required: isShowGet, message: '请选择',}]}]"
                            >
                                <a-select-option :value="item.id" v-for="item in ticketCouponsList" :key="item.id">{{item.name}}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>

                </a-card>
                
                <a-row class="text-center">
                    <a-button class="mr8" @click="$router.go(-1)">返回</a-button>
                    <a-button v-if="!isDisable" type="primary" @click="handleSubmit" :loading="loading">新增</a-button>
                </a-row>
            </a-form>
        </div>

    </content-view>
</template>

<script type="text/javascript">
    import moment from "moment";

    export default {
        name: "newAddcoupons",
        components: {},
        props: {},
        data() {
            return {
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 7 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 11 }
                    }
                },

                required: 1,
                type: 1,
                validEndTime: undefined,
                validStartTime: undefined,
                reachAmount: undefined,
                reduceAmount: undefined,
                discountRate: undefined,

                isShareCoupons: false,
                isTicketCoupons: false,
                showReward: true,
                isDisable: false,
                isShowTicket: true,
                isShowTicketList: false,
                isShowSendTime: false,
                ticketList: [],
                ticketRewardList: [],
                ticketIdList: [],
                isShowValidDates: false,

                // 领取条件
                isShowGet: true,
                isShowGetCondition: true,
                isShowCoupons: true,
                ticketCouponsList: [],
                loading: false,
                isDisabledForSendTime: false
            };
        },
        computed: {},
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            moment,
            onChangePicker(value, data) {
                this.validStartTime = data[0];
                this.validEndTime = data[1];
            },
            // 切换有无门槛
            onChangeRequired() {
                this.reachAmount = undefined
                this.reduceAmount = undefined
                this.discountRate = undefined
            },
            //适用票种
            onChangeTicketType(e) {
                this.isShowTicket = e.target.value === 1
            },
            onChangeSuitTicket(e) {
                this.isShowTicketList = e.target.value === 1
                this.$nextTick(() => {
                    this.form.validateFields(['ticketRewardList'], { force: true });
                })
            },
            // 查看详情--获取优惠券详情
            getCouponsDetail(id) {
                this.$api.totalPlatform
                .couponDetail({
                    params: {id: id}
                }).then(res => {
                    this.isDisable = true
                    let {
                        name,
                        type,
                        sendType,
                        sendTimeOption,
                        limitNum,
                        sendTime,
                        behaviorType,
                        takeCondition,
                        ticketName,
                        useType,
                        userLimit,
                        dateType,
                        shareRemark
                    } = res
                    let valuesForm = {
                        name: name,
                        type: type,
                        behaviorType,
                        takeCondition,
                        ticketId: ticketName,
                        useType,
                        userLimit,
                        sendType: Number(sendType),
                        sendTimeOption: Number(sendTimeOption),
                        limitNum: limitNum,
                        dateType: dateType,
                        shareRemark: shareRemark,
                        sendTime: moment(sendTime,'YYYY-MM-DD HH:mm:ss'),
                        // setTime: [moment(res.behaviorStartTime,'YYYY-MM-DD HH:mm:ss'),moment(res.behaviorEndTime,'YYYY-MM-DD HH:mm:ss')],
                    }
                    this.type = type;
                    (res.validStartTime && res.validEndTime) && (valuesForm.rangePicker = [moment(res.validStartTime,'YYYY-MM-DD HH:mm:ss'),moment(res.validEndTime,'YYYY-MM-DD HH:mm:ss')])
                    
                    this.isShowSendTime = sendTimeOption === 0
                    this.isShowGetCondition = sendTimeOption === 1
                    this.isShowGet = takeCondition === 1

                    if(dateType === 0) {
                        valuesForm.validDates = res.validDates
                    }// }else {
                        valuesForm.setTime = [moment(res.behaviorStartTime,'YYYY-MM-DD HH:mm:ss'),moment(res.behaviorEndTime,'YYYY-MM-DD HH:mm:ss')]
                    // }

                    if(type === 3) { // 分享券
                        this.isShareCoupons = true
                        valuesForm.couponId = res.couponId ? (res.couponId + '') : res.couponId
                        valuesForm.rewardType = res.rewardType
                        valuesForm.rewardId = res.rewardId + ''
                    }else { // 优惠券、折扣券
                        this.isShareCoupons = false
                        this.required = res.required
                        this.reachAmount = res.reachAmount
                        this.reduceAmount = res.reduceAmount
                        this.discountRate = res.discountRate * 10
                        this.isShowTicket = res.suitType == 1
                        this.isShowTicketList = res.suitTicketOption == 1
                        valuesForm.suitType = res.suitType
                        valuesForm.suitTicketOption = res.suitTicketOption
                        valuesForm.ticketIdList = res.ticketIds.split(', ')
                    }
                    if(valuesForm.rewardType === 1) { // 关联奖励优惠券
                        this.getRewardCoupons()
                    }else if(valuesForm.rewardType === 2) { // 关联奖励票券
                        this.getSuitTickets()
                    }
                    if(useType === 1) { // 优惠券
                        this.getTriggerCoupons()
                        this.isShowCoupons = true
                    }else { // 票券
                        this.getTriggerTickets()
                        this.isShowCoupons = false
                    }
                    this.$nextTick(() => {
                        this.form.setFieldsValue(valuesForm)
                    })

                })
            },
            // 切换优惠券类型
            onChangeType(e) {
                this.isShareCoupons = e.target.value === 3
                this.showReward = e.target.value === 3
                this.type = e.target.value
                this.showReward && this.getRewardCoupons()

                this.reachAmount = undefined
                this.reduceAmount = undefined
                this.discountRate = undefined
            },
            // 切换发送时间
            onChangeSendTime(e) {
                this.isShowSendTime = e.target.value === 0
                if(e.target.value === 1) {
                    this.isShowGetCondition = true
                    this.isShowGet = true
                    this.isDisabledForSendTime = false 
                    this.$nextTick(() => {
                        this.form.setFieldsValue({['takeCondition']: 1});
                    })
                }else {
                    this.isShowGetCondition = false
                    this.isShowGet = false
                    this.$nextTick(() => {
                        this.form.setFieldsValue({['takeCondition']: ''});
                    })
                }
                this.$nextTick(() => {
                    this.form.validateFields(['sendTime','setTime','behaviorType','ticketId'], { force: true });
                })
            },

            // 切换领取条件
            onChangeShowGet(e) {
                this.isShowGet = e.target.value === 1
                this.$nextTick(() => {
                    this.form.validateFields(['setTime','behaviorType','ticketId'], { force: true });
                })
            },

            // 关联票券列表
            getRelationCoupons() {
                this.$api.totalPlatform
                .relationCoupons().then(res => {
                    this.ticketList = res
                })
            },
            // 切换奖励券类型
            onChangeRewardType(e) {
                e.target.value === 2 ? this.getSuitTickets() : this.getRewardCoupons()
                this.showReward = e.target.value === 0 ? false : true
                this.$nextTick(() => {
                    this.form.validateFields(['rewardId'], { force: true });
                    this.form.setFieldsValue({['rewardId']: ''});
                })
            },
            // 关联奖励优惠券列表
            getRewardCoupons() {
                this.$api.totalPlatform
                .rewardCoupons().then(res => {
                    this.ticketRewardList = res
                })
            },
            // 关联奖励票券列表
            getSuitTickets() {
                this.$api.totalPlatform
                .suitTickets().then(res => {
                    this.ticketIdList = res
                    this.ticketRewardList = res
                })
            },

            // 用户使用类型 优惠券列表
            getTriggerCoupons() {
                this.$api.totalPlatform
                .triggerCoupons().then(res => {
                    this.ticketCouponsList = res
                })
            },
            // 用户使用类型 票券列表
            getTriggerTickets() {
                this.$api.totalPlatform
                .triggerTickets().then(res => {
                    this.ticketCouponsList = res
                })
            },
            
            // 切换用户使用类型
            onChangeUseType(e) {
                this.isShowCoupons = e.target.value === 1
                this.ticketCouponsList = e.target.value === 2 ? this.getTriggerTickets() : this.getTriggerCoupons()
                this.$nextTick(() => {
                    this.form.setFieldsValue({['ticketId']: '',['behaviorType']: ''});
                })
            },

            // 切换生效时间类型
            onChangeTime(e) {
                this.isShowValidDates = e.target.value === 1
                this.$nextTick(() => {
                    this.form.setFieldsValue({['validDates']: '',['rangePicker']: []});
                    this.form.validateFields(['validDates','rangePicker'], { force: true });
                })
            },

            handleSubmit() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        if(values.type !== 3) {
                            if(this.required == 1 && this.type == 1 && (!this.reachAmount || !this.reduceAmount)) {
                                this.$message.error('请输入使用门槛')
                                return false
                            }
                            if(this.required == 1 && this.type == 2 && (!this.reachAmount || !this.discountRate)) {
                                this.$message.error('请输入使用门槛')
                                return false
                            }
                            if(this.required == 0 && this.type == 1 && !this.reduceAmount) {
                                this.$message.error('请输入使用门槛')
                                return false
                            }
                            if(this.required == 0 && this.type == 2 && !this.discountRate) {
                                this.$message.error('请输入使用门槛')
                                return false
                            }
                        }
                        if(this.isShowValidDates) {
                            if(values.rangePicker.length == 0) {
                                this.$message.error('请选择指定有效期')
                                return false
                            }
                        }else {
                            if(!values.validDates) {
                                this.$message.error('请输入有效期天数')
                                return false
                            }
                        }
                        // if(this.isShowGet && moment(this.validEndTime).isBefore(values.setTime[1].format('YYYY-MM-DD HH:mm:ss'))) {
                        //     this.$message.error('限定时间不能超过生效时间，请修改后保存')
                        //     return false
                        // }
                        delete values.rangePicker

                        this.loading = true
                        this.$api.totalPlatform
                        .addCoupon({
                            body: {
                                ...values,
                                reachAmount: this.reachAmount,
                                reduceAmount: this.reduceAmount,
                                discountRate: this.discountRate/10,
                                required: this.required,
                                validEndTime: this.validEndTime,
                                validStartTime: this.validStartTime,
                                sendTime: values.sendTime ? values.sendTime.format('YYYY-MM-DD HH:mm:ss') : undefined,
                                behaviorStartTime: values.setTime ? values.setTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined,
                                behaviorEndTime: values.setTime ? values.setTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined,
                            }
                        })
                        .then(
                            res => {
                                this.$router.push({ name: "coupon" });
                                this.$message.success("操作成功", 2);
                                this.loading = false
                            },
                            err => {
                                this.$message.error(err.mag, 2);
                                this.loading = false
                            }
                        );
                    }
                });
            },
        },
        created() {},
        mounted() {
            this.getRelationCoupons()
            this.getRewardCoupons()
            this.getSuitTickets()
            this.getTriggerCoupons()
            if(this.$route.name === 'couponDetail') {
                this.getCouponsDetail(this.$route.query.id)
            }
        }
    };
</script>
<style lang="scss">
.newAddcoupons {
  background: #fff;
  padding: 24px 32px;
  border-radius: 2px;
}
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
</style>
